import React from 'react';
import './Statistics.css';

const statisticsPoints = [
  { id: 1, content: 'Cut admin by 35–55% and get paid 20–30% faster with automated quotes, phase-wise invoices, and smart reminders.', size: 'medium' },
  { id: 2, content: 'Avoid 1–3 hires as you scale to 25 clients.', size: 'small' },
  { id: 3, content: 'Deliver on time with 25–40% faster project cycles and client visibility at every milestone.', size: 'small' },
  { id: 5, content: '20–30% faster quote-to-cash by linking quotes → invoices → automated reminders and upcoming online payments.', size: 'medium' },
  { id: 4, content: '35–55% less admin time per project by consolidating quotes, invoices, client data, and project milestones into one system, eliminating duplicative entry.', size: 'large' },
  { id: 6, content: '1–3 headcount avoided at 10–25 active clients through automation of billing, reminders, expense import, and phase-wise invoicing.', size: 'large' },
  { id: 7, content: '25–40% fewer payment delays due to automated dunning and client portal visibility into status and due dates.', size: 'small' },
  { id: 8, content: '30–50% fewer client follow-ups needed as status, documents, and milestones live in one place with client-facing views.', size: 'medium' },
];

function Statistics() {
  return (
    <section id="statistics" className="statistics-section container">
      <h3 className="statistics-title fade-up">Proven Numbers That Power Growth</h3>
      <p className="statistics-text fade-up">
        Real, measurable impact across your operations from finance to delivery. BOSS turns scattered system into professional funnel.
      </p>
      <div className="statistics-masonry fade-up">
        {statisticsPoints.map(({ id, content, size }) => (
          <div
            key={id}
            className={`statistics-card fade-up ${size}`}
          >
            <p>{content}</p>
          </div>
        ))}
      </div>
      <p className="supporting-statement fade-up">
        "Less manual work. Faster cash flow. Smarter scaling — that’s the BOSS effect in action."
      </p>
    </section>
  );
}

export default Statistics;
